export const actionTypes = {
  setTblBpmnObjects: "setTblBpmnObjects",
  setTblBreObjects: "setTblBreObjects",

};
const initstate = {
  TblBpmnObjects: [],
  TblBreObjects: [],
};
export const graphInfoReducer = (state = initstate, action) => {
  switch (action.type) {
    case actionTypes.setTblBpmnObjects:
      return { TblBpmnObjects: action.payload };
      case actionTypes.setTblBreObjects:
        return { TblBreObjects: action.payload };
    default:
      return state;
  }
};
export const graphInfoActions = {
  
  setTblBpmnObjects: (TblBpmnObjects) => ({ type: actionTypes.setTblBpmnObjects, payload: TblBpmnObjects }),
  setTblBreObjects: (TblBreObjects) => ({ type: actionTypes.setTblBreObjects, payload: TblBreObjects }),

};
